import { render, staticRenderFns } from "./AdditionalFieldsSelect.vue?vue&type=template&id=7ed5dafe&scoped=true&lang=pug&"
import script from "./AdditionalFieldsSelect.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFieldsSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed5dafe",
  null
  
)

export default component.exports